import Login from "./components/login/Login";

const UnAuthenticatedApp = () => {
  return <Login />;
};

export default UnAuthenticatedApp;
